<app-toastr-message
    *ngFor="let toaster of toasters; trackBy: toasterById"
    @closeToaster
    [toaster]="toaster"
    (closed)="onClosed($event)">
</app-toastr-message>
